// extracted by mini-css-extract-plugin
export default {"cls1":"WXoFbxoyeu7bX2Dco2zs","cls2":"qYbF5yzprU0uUCgkuvO6 WXoFbxoyeu7bX2Dco2zs"};